import { useEffect, useRef } from 'react';

import { loadWidget } from '@cast/utils';

import { useUser } from '@cast/infrastructure-auth';

export const useInitSupportChat = () => {
  const user = useUser();
  const isInitialized = useRef(false);
  useEffect(() => {
    const appId = window.env.VITE_PYLON_CHAT_APP_ID;
    if (!user || !appId || isInitialized.current) {
      return;
    }

    loadWidget({
      name: user.name,
      email: user.email,
      emailHash: user.emailHash,
      appId,
    });
    isInitialized.current = true;
  }, [user]);
};
